/* eslint-disable @typescript-eslint/indent */

/* Note: please be careful with indentation, we have the rule disabled because of
*  eslint not being able to properly indent js inside styled components
*/

// Core
import styled from 'styled-components';

// Config
import { BREAKPOINTS } from '../../../../../../config/screen';

/* *************************************** COMPONENTS ***************************************** */

export const CustomChartContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  min-height: 0;
  position: relative;
`;

export const ChipsRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding-bottom: 0.75rem;
`;

export const SeriesChipsContainer = styled.div`
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  gap: 8px;
  flex: 1;
  min-width: 0;
  overflow-x: auto;

  @media (min-width: ${BREAKPOINTS.lg}px) {
    flex-wrap: wrap;
    flex: initial;
    overflow-x: visible;
  };
`;

export const EmptyBoxContainer = styled.div`
  flex: 1;
  min-height: 0;
  padding-bottom: 4rem;
  box-sizing: border-box;
  overflow: hidden;
  font-size: 28px;

  > div {
    height: auto;
    min-height: 100%;
    padding: 0.75rem 1rem 1rem;
    gap: 8px;
  };

  @media (min-width: ${BREAKPOINTS.lg}px) {
    padding-bottom: 6rem;
    font-size: 60px;

    > div {
      height: 100%;
      min-height: unset;
      padding: 2.5rem;
      gap: 32px;
    };
  };
`;

export const SelectTagsButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 0.5rem 0;
  background: ${({ theme }) => theme.color.crusherDashboard.trendings.customChartGradientColor};

  @media (min-width: ${BREAKPOINTS.lg}px) {
    padding: 1rem 0;
  };
`;
